import { ButtonItemActionsComponent } from './button-item-actions.component';

export default angular
  .module('sfMobile.components.button-item-actions', [])
  .component('sfButtonItemActions', ButtonItemActionsComponent).name;
